import { songs } from "../constants";
import { Song } from "../types/song";

const maxResults = 20;

export function searchSong(searchTerm: string): Song[] {
  if (!searchTerm?.length) return [];

  function fuzzyMatch(input: string) {
    return input.toLowerCase().replace(/[^0-9a-z ]/gi, "");
  }
  searchTerm = fuzzyMatch(searchTerm);

  // Lower is better: starts with the search, then a word starting with it,
  // then anywhere. -1 means no match.
  function rank(song: Song) {
    const fields = [song.name, song.artist, `${song.artist} ${song.name}`].map(
      fuzzyMatch
    );
    if (fields.some((field) => field.startsWith(searchTerm))) return 0;
    if (fields.some((field) => field.includes(` ${searchTerm}`))) return 1;
    if (fields.some((field) => field.includes(searchTerm))) return 2;
    return -1;
  }

  // The list has a few repeats; show each song once
  const seen = new Set<string>();

  return songs
    .map((song: Song) => ({ song, rank: rank(song) }))
    .filter(({ rank }) => rank >= 0)
    .sort(
      (a, b) =>
        a.rank - b.rank ||
        a.song.artist.toLowerCase().localeCompare(b.song.artist.toLowerCase()) ||
        a.song.name.toLowerCase().localeCompare(b.song.name.toLowerCase())
    )
    .map(({ song }) => song)
    .filter((song) => {
      const key = `${song.artist}|${song.name}`.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, maxResults);
}
